// OPTIONSInertialDampingDropDown.tsx
import {useState} from "react";
import * as React from "react";
import "./index.css"
import { InertDampingWords } from "./swmm_core/wordsnKeys"

const OPTIONSInertialDampingDropDown = ({INERTIAL_DAMPING, onChange}:any) => {
  const [selected, setSelected] = useState('')

  // If the controlling element changes, then 
  // the displayed value must also change.
  React.useEffect(() => {
    setSelected(INERTIAL_DAMPING)
  }, [INERTIAL_DAMPING])

  const handleChange = ({target}:any) =>{
    setSelected(target.value)
    onChange({name: 'INERTIAL_DAMPING', value: target.value})
  }

  return(
    <div>
      <select
        className = 'UIparams swmmDropDown'
        value={selected}
        onChange={handleChange}
      >{InertDampingWords.map(( value , index ) => <option className = 'UIparams' key={index} value={value}>{value}</option>)}
      </select>
    </div>
  )
}
 
export {OPTIONSInertialDampingDropDown};